var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sa-icon',{attrs:{"name":"common-icon-border-add"}}),_c('p',[_vm._v("---------------------------------")]),_c('sa-common-icon-add1',{staticStyle:{"font-size":"30px","color":"red"},attrs:{"config":{theme: 'filled'}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }